import BaseServie from '@/services/baseService';
import { AxiosResponse } from 'axios';
import { DokumentEditApiDto, DokumentApiDtoSearchResponseApi, LieferantenDokumentApiDtoSearchResponseApi } from '@/api-schema';
import { DokumentFilterDto } from '@/types/DokumentFilterDto';
import { ILieferantenDokumentArchivService } from '@/areas/administration/services/ILieferantenDokumentArchivService';
import { LieferantenDokumentFilterDto } from '@/types/LieferantenDokumentFilterDto';

export class LieferantenDokumentArchivService extends BaseServie implements ILieferantenDokumentArchivService {
    private EXTENDED_RESOURCE_URL: string;
    private RESOURCE_URL: string;
    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}dokumente`;
        this.EXTENDED_RESOURCE_URL = `${this.RESOURCE_URL}/lieferant`;

        console.debug('ArchivService::constructor', this.EXTENDED_RESOURCE_URL);
    }
    async deleteDokument(id: number): Promise<object> {
        return super.DELETE(`${this.EXTENDED_RESOURCE_URL}/${id}`).then((response) => {
            return response;
        });
    }
    async downloadDokument(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.RESOURCE_URL}/download/` + id).then((response) => {
            return response;
        });
    }

    async getAll(filter: LieferantenDokumentFilterDto): Promise<LieferantenDokumentApiDtoSearchResponseApi> {
        return super
            .GET<LieferantenDokumentApiDtoSearchResponseApi>(`${this.EXTENDED_RESOURCE_URL}/` + super.serializeObjectToQuerystring(filter))
            .then((response) => {
                return response;
            });
    }
    async getDokument(id: number): Promise<DokumentEditApiDto> {
        return super.GET<DokumentEditApiDto>(`${this.EXTENDED_RESOURCE_URL}/${id}`).then((response) => {
            return response;
        });
    }
}

export const lieferantenDokumentArchivService = new LieferantenDokumentArchivService();
